import { Switch } from 'govwell-ui'

import { Size } from '../../../govwell-ui/types'
import { TanstackField } from '../../../utils/forms'

type SwitchFieldProps<TKey extends string> = {
  align?: 'left' | 'right'
  caption?: React.ReactNode
  children?: React.ReactNode
  field: TanstackField<boolean, TKey>
  isDisabled?: boolean
  isInvalid?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  size?: Size
}

const SwitchField = <TKey extends string>({
  align = 'left',
  caption,
  children,
  field,
  isDisabled,
  isInvalid: propIsInvalid,
  isRequired,
  label,
  size,
}: SwitchFieldProps<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = propIsInvalid || !!errorMessage
  return (
    <Switch
      {...(children
        ? { children, label }
        : label
          ? { label }
          : { ariaLabel: typeof label === 'string' ? label || 'Toggle' : 'Toggle' })}
      align={align}
      caption={caption}
      errorMessage={errorMessage}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      size={size}
      onValueChange={field.setValue}
      value={field.state.value ?? false}
    />
  )
}

export default SwitchField
